import { useState } from 'react';
import { connect } from 'react-redux';

import { Table } from '@devexpress/dx-react-grid-bootstrap4';
import { useComponentDidMount } from '../core/hooks';
import * as actions from './store/actions';
import * as vehicleActions from '../vehicles/store/actions';
import CarmenVehicleSelect from './CarmenVehicleSelect';
import { DataTable } from '../core/components/datatable';

// interface CarmenMakeCompatTableProps {
//   carmenMakes?: unknown[]
//   makes?: unknown[]
//   getCarmenMakes?(...args: unknown[]): unknown
//   getVehicleMakes?(...args: unknown[]): unknown
// }

const CarmenMakeCompatTable = props => {
  const {
    getCarmenMakes,
    getVehicleMakes,
    carmenMakes,
    makes,
  } = props;

  const [loading, setLoading] = useState(false);

  const columns = [
    { name: 'id', title: 'ID', width: 100 },
    { name: 'carmenName', title: 'Название из Carmen', width: 'auto' },
    {
      name: 'avtoappMake',
      title: 'Название из AvtoApp',
      getCellValue: row => <CarmenVehicleSelect makes={ makes } carmenMake={ row } />,
      width: 350,
    },
  ];

  const loadData = async () => {
    setLoading(true);
    try {
      await getCarmenMakes();
      await getVehicleMakes();
    } finally {
      setLoading(false);
    }
  };

  useComponentDidMount(() => {
    loadData();
  });

  return (
    <>
      <h4 className='mb-4'>Таблица совместимости производителей авто из Carmen</h4>
      <DataTable
        columns={ columns }
        data={ carmenMakes }
        loading={ loading }
        columnsResizingMode='nextColumn'
        dataCellComponent={ (cellProps) => {
          if (cellProps.column.name === 'avtoappMake') {
            return <Table.Cell { ...cellProps } className='overflow-visible' />;
          }
          return <Table.Cell { ...cellProps } />;
        } }
        localPaging
        localSorting
        hideToolbar
      />
    </>
  );
};

const mapStateToProps = state => ({
  carmenMakes: state.carmen.carmenMakes,
  makes: state.vehicles.makes,
});

const mapDispatchToProps = {
  getCarmenMakes: actions.getCarmenMakes,
  getVehicleMakes: vehicleActions.getVehicleMakes,
};

export default connect(mapStateToProps, mapDispatchToProps)(CarmenMakeCompatTable);
